import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className="ri-camera-3-line text-xl text-primary-400"></i>
              </div>
              <span className="font-heading text-base font-semibold text-background-50">
                偷拍自拍技巧大全
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              分享最实用的自然感自拍技巧，帮每一位摄影爱好者拍出真实、有故事感的日常瞬间。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">
              摄影分类
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#contact" className="text-sm text-background-400 hover:text-primary-400 transition-colors">
                  联系我们
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">
              关注我们
            </h4>
            <div className="flex items-center gap-3">
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors"
                aria-label="微信"
              >
                <i className="ri-wechat-line text-background-200"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors"
                aria-label="微博"
              >
                <i className="ri-weibo-line text-background-200"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors"
                aria-label="小红书"
              >
                <i className="ri-red-packet-line text-background-200"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 偷拍自拍技巧大全. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">
              隐私政策
            </a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}